var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { toJS, computed, makeObservable } from 'mobx';
import { UserPermission } from './modules/UserPermission';
import { UserInfo } from './modules/UserInfo';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { APIData } from '../api/APIData';
import { toNumber } from '../../utils/helper/lodash_replacements';
import { UserStore } from './modules/UserStore';
export class User {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get app() {
        return this.parent;
    }
    get id_string() {
        return this.app.appCookies.get('elearning_userId');
    }
    get id() {
        return toNumber(this.id_string);
    }
    get userQuery() {
        return new APIData({
            route: '/api/user/user',
            defaultValue: undefined,
        });
    }
    get userData() {
        return this.userQuery.streamedDeep;
    }
    get userStore() {
        return new UserStore(this);
    }
    get userPermissions() {
        return new UserPermission(this);
    }
    get userInfo() {
        return new UserInfo(this);
    }
    get displayUserString() {
        let s = this.userData.email;
        if (this.userData.prename.length > 0)
            s += ` - ${this.userData.prename}`;
        return s;
    }
    get photoURL() {
        if (this.userData.ownImage && this.userData.ownImage.length > 0)
            return this.userData.ownImage;
        /*const a = _.get(this,'parent.auth.photoURL','');
                if (a && a.length > 0)return a; */
        return '';
    }
    get instanceLocation() {
        return this.app.model.stream.path[`${this.userData.instance}`];
    }
    get schooltypeLocation() {
        return this.app.model.stream.path[`${this.userData.instance}/${this.userData.schooltype}`];
    }
    get formLocation() {
        return this.app.model.stream.path[`${this.userData.instance}/${this.userData.schooltype}/${this.userData.form}`];
    }
    get plainUserData() {
        return toJS(this.userData);
    }
    get isGuestAccount() {
        return this.userData.guest === 1 && this.userData.email.startsWith('gast');
    }
}
__decorate([
    memoize
], User.prototype, "id_string", null);
__decorate([
    memoize
], User.prototype, "userQuery", null);
__decorate([
    memoize
], User.prototype, "userStore", null);
__decorate([
    memoize
], User.prototype, "userPermissions", null);
__decorate([
    memoize
], User.prototype, "userInfo", null);
__decorate([
    computed.struct
], User.prototype, "plainUserData", null);
